import { render } from "./ReportsKpiSection.vue?vue&type=template&id=206d7d57"
import script from "./ReportsKpiSection.vue?vue&type=script&lang=js"
export * from "./ReportsKpiSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__